import React from 'react'
import { useState, useRef } from 'react';
import logo from '../Assets/img/logo.png';
import profileIcon from '../Assets/img/du.jpg';
import { Link, NavLink } from 'react-router-dom';
import { GoBack } from './GoBack';
import GetRequest from '../Services/APIRequest'

function sidebarOff() {
  if (window.innerWidth < 991) {
    document.querySelector('.boostapp').classList.remove('active');
  }
}

const Sidebar = () => {

  const bpuID = localStorage.getItem('userId');
  const [selectFormVal, setSelectFormVal] = useState("");
  var data = {};
  var { data } = GetRequest(`/User/GetDistributorsAssignedToUser/${bpuID}`);

  if (localStorage.getItem('distributorId') !== null && localStorage.getItem('distributorId') !== '-1') {

  }

  const handleSelectFormChange = (event) => {
    setSelectFormVal(event.target.value);
    localStorage.setItem('distributorId', event.target.value);
    if (localStorage.getItem('distributorId') !== '') {
      document.getElementById('distPayOrdViewLink').classList.remove('hide')
    } else {
      document.getElementById('distPayOrdViewLink').classList.add('hide')
    }

  }

  return (
    <>
      <aside className="main-sidebar">

        <span className="brand-link">  <img src={logo} width="60" alt="Logo" /> </span>

        <div className="sidebar">
          <div className="user-panel">
            <div className="image">
              <img src={profileIcon} className="Profimg" alt="User Icon" />
            </div>
            <div className="info">
              <Link to={'ProfileDashboard'} className="d-block ellipseTextWrap"> <div className='profNameSidebar'>Welcome {localStorage.getItem('distributorDisplayName')} </div>  <i className="fa fa-angle-right faconProLink"></i>    </Link>
            </div>
          </div>
          <nav className="sideNavbarItem">
            <h6 id="top"> </h6>
            <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false" id="distributorNavList">
              <li className="nav-item" id='arrow-up-sidebar'>
                <NavLink activeclassname="active" to="/" className="nav-link" onClick={sidebarOff}>
                  <i className="nav-icon fa fa-dashboard"></i>
                  <span> Home </span>
                </NavLink>
              </li>
              {/* <li className="nav-item">
                <NavLink activeclassname="active" to="/NewOrder" className="nav-link" onClick={sidebarOff}>
                  <i className="nav-icon fa fa-shopping-cart"></i>
                  <span>  New Order </span>
                </NavLink>
              </li> */}
              <li className="nav-item">
                <NavLink activeclassname="active" to="/Products" className="nav-link" onClick={sidebarOff}>
                  <i className="nav-icon fa fa-product-hunt"></i>
                  <span> Product Info  </span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink activeclassname="active" to="/Videos" className="nav-link" onClick={sidebarOff}>
                  <i className="nav-icon fa fa-shopping-cart"></i>
                  <span>  Videos </span>
                </NavLink>
              </li>
              {/* <li className="nav-item">
                <NavLink activeclassname="active" to="/Yashogatha" className="nav-link" onClick={sidebarOff}>
                  <i className="nav-icon fa fa-shopping-cart"></i>
                  <span>  Yashogatha </span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink activeclassname="active" to="/Articles" className="nav-link" onClick={sidebarOff}>
                  <i className="nav-icon fa fa-shopping-cart"></i>
                  <span>  Articles </span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink activeclassname="active" to="/Tips" className="nav-link" onClick={sidebarOff}>
                  <i className="nav-icon fa fa-shopping-cart"></i>
                  <span>  Tips </span>
                </NavLink>
              </li> */}
              <li className="nav-item">
                <NavLink activeclassname="active" to="/MyOrder" className="nav-link" onClick={sidebarOff}>
                  <i className="nav-icon fa fa-cart-plus"></i>
                  <span> My Orders </span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink activeclassname="active" to="/ShareObservations" className="nav-link" onClick={sidebarOff}>
                  <i className="nav-icon fa fa-question-circle-o"></i>
                  <span>   Share Observation</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink activeclassname="active" to="/OurTeamContacts" className="nav-link" onClick={sidebarOff}>
                  <i className="nav-icon fa fa-question-circle-o"></i>
                  <span>   Our Team Contacts</span>
                </NavLink>
              </li>
              {/* <li className="nav-item">
                <NavLink activeclassname="active" to="/Recommendation" className="nav-link" onClick={sidebarOff}>
                  <i className="nav-icon fa fa-question-circle-o"></i>
                  <span>  Recommendation</span>
                </NavLink>
              </li> */}
              {/* <li className="nav-item">
                <NavLink activeclassname="active" to="/Events" className="nav-link" onClick={sidebarOff}>
                  <i className="nav-icon fa fa-question-circle-o"></i>
                  <span>   Events</span>
                </NavLink>
              </li> */}
            </ul>
            <h6 id="bottom"></h6>
          </nav>
          <a href="#bottom" className='arrow-down-sidebar hide'></a>
          <a href="#top" className='arrow-up-sidebar hide'></a>
        </div>
      </aside>
    </>
  )
}

export default Sidebar